export enum RowSeatsOrders {
  LEFT_TO_RIGHT,
  RIGHT_TO_LEFT
}
